dealershipModule.factory('dealerPackService',
    ['commonRESTCallService', 'AppSettings', 'DealerPack', 'imSessionVarsService', 'erateSessionVarsService', 'providerFeaturesService', 'settingsCacheService', 'dealershipModuleConstants', '$q',

    function(commonRESTCallService, AppSettings, DealerPack, imSessionVarsService, erateSessionVarsService, providerFeaturesService, settingsCacheService, dealershipModuleConstants, $q) {
        var api = {};

        var _fallbackTermLabelSet =
        {
            productType: '*',
            terms: [ {key: "single", label: "Amount"}]
        };

        // Very simple cache, depends on provider.  Cached values are never persisted to data store.
        var _cachedTermLabelSets  =
        {
            providerCode: "*NONE*",
            data: []
        };

        function getCachedTermLabelSets(providerCode) {
            if (_cachedTermLabelSets.providerCode === providerCode) {
                return _cachedTermLabelSets.data;
            }
            return null;
        }

        function setCachedTermLabelSets(providerCode, termLabelSets) {
            _cachedTermLabelSets.providerCode = providerCode;
            _cachedTermLabelSets.data = termLabelSets;
        }


        api.getProviderTermLabelSets = function () {
            var deferred = $q.defer();

            // try to fetch from local cache first
            var providerCode =  imSessionVarsService.getCurrentProviderCode();
            var cached = getCachedTermLabelSets(providerCode);

            if (cached) {
                deferred.resolve(cached);
                return deferred.promise;
            }

           // clear the cache, defensive
           setCachedTermLabelSets("*NONE*", []);

            var strategy = "UI", featureName = "dealer-pack-setting";
            providerFeaturesService.getFeatureMetadata(strategy, featureName)
                .then(function(json) {
                    // see tests for example of what json represents
                    var featureValue = angular.fromJson(json)
                    var termLabelSets = makeTerminatedLabelSets(featureValue);
                    setCachedTermLabelSets(providerCode, termLabelSets);
                    deferred.resolve(termLabelSets);
                },
                function(data) {
                    // Todo: fix this hack. Need better way to detect not found
                    if (angular.isString(data)  && data.indexOf("No metadata") >= 0)
                    {
                        // metadata not found is ok, any other error is not
                        var defaultTermLabelSets = makeTerminatedLabelSets([]);
                        setCachedTermLabelSets(providerCode, defaultTermLabelSets);
                        deferred.resolve(defaultTermLabelSets);
                        return;
                    }
                    deferred.reject(angular.isString(data) ? data  : JSON.stringify(data));
                });
            return deferred.promise;
        };

        api.getMarkUpAllowed = function () {
            // try to fetch from local cache first
            var providerCode =  imSessionVarsService.getCurrentProviderCode();

            var strategy = "UI", featureName = "allow-markup-setting";
            return providerFeaturesService.getFeatureMetadata(strategy, featureName, false)
                .then(function(json) {
                        // see tests for example of what json represents
                        var featureValue = angular.fromJson(json);
                        return featureValue;
                    });
        };

        function makeTerminatedLabelSets(labelSet) {
            var result = (labelSet || []).concat(_fallbackTermLabelSet);
            return angular.copy(result);
        }

        api.getProviderPackSettings = function() {
            var deferred = $q.defer();
            // todo: Get from Identity Management - this is for ApCo
            var responseData =
            {
                duplication: "DUPLICATE"  // UNIQUE or DUPLICATE
            };
            deferred.resolve(responseData);
            return deferred.promise;
        };

        api.getDealerPacks = function(productCode, dateOfSale) {
            // promise chaining; this returns a promise to the caller
            return this.getProviderTermLabelSets()
                .then(function(labelSets) {
                    return getDealerPacksPrivate(productCode, dateOfSale, labelSets);
                });
        };

        function getDealerPacksPrivate(productCode, dateOfSale, termLabelSets) {
            var deferred = $q.defer();

            if (!(dateOfSale instanceof Date)) {
                dateOfSale = new Date(dateOfSale);
            }

            var cachedDealerPacks = settingsCacheService.getCachedDealerPacks(productCode, dateOfSale);
            if (cachedDealerPacks) {
                deferred.resolve(cachedDealerPacks);
            } else {
                var dateStr = dateOfSale.mmddyyyy();

                var providerCode = imSessionVarsService.getCurrentProviderCode();
                var dealerAccount = erateSessionVarsService.getCurrentDealerAccountCode();

                var url = AppSettings.startSPANDealerPackSettingsURL + "/GetDealerPackSettings/" + providerCode + "/" + dealerAccount + "/" + dateStr + "/" + productCode;
                commonRESTCallService.getFromServer(url)
                    .then(function (response) {
                        var bsPacks = response && response.data || [];
                        var packs = convertPacksFromBusServices(bsPacks, termLabelSets);
                        settingsCacheService.setCachedDealerPacks(productCode, dateOfSale, packs);
                        deferred.resolve(packs);
                    },
                    function (data, status) {
                        deferred.reject(status + JSON.stringify(data));
                    });
            }
            return deferred.promise;
        }

        api.getAllDealerPacks = function(dateOfSale) {
            // promise chaining; this returns a promise to the caller
            return this.getProviderTermLabelSets()
                .then(function(labelSets) {
                    return getAllDealerPacksPrivate(dateOfSale, labelSets);
                });
        };

        function getAllDealerPacksPrivate(dateOfSale, labelSets) {
            var deferred = $q.defer();

            if (!(dateOfSale instanceof Date)) {
                dateOfSale = new Date(dateOfSale);
            }

            var dateStr = dateOfSale.mmddyyyy();

            settingsCacheService.clearCachedDealerPacks();

            var providerCode =  imSessionVarsService.getCurrentProviderCode();
            var dealerAccount = erateSessionVarsService.getCurrentDealerAccountCode();

            var url = AppSettings.startSPANDealerPackSettingsURL + "/GetDealerPackSettings/" + providerCode + "/" + dealerAccount + "/" + dateStr;
            commonRESTCallService.getFromServer(url)
                .then(function(response) {
                    var bsPackGroups = response && response.data || [];
                    bsPackGroups = prependDefault(bsPackGroups);
                    var packGroups = convertPackGroupsFromBusServices(bsPackGroups, labelSets);
                    packGroups.forEach(function(packGroup) {
                        settingsCacheService.setCachedDealerPacks(packGroup.productCode, dateOfSale, packGroup.packs);
                    });
                    deferred.resolve(packGroups.slice(1));  // drop the default object from the beginning, now that we have it in the cache
                },
                function(data, status) {
                    deferred.reject(status + JSON.stringify(data));
                });

            return deferred.promise;
        }

         function prependDefault(data) {
            // Server should provide default as first item in data.  But if it is missing,
            // we will insert one here efault here.
            if (data.length == 0  || data[0].key != dealershipModuleConstants.DEFAULT_PRODUCT) {
                var bsPackGroup = {
                    key: dealershipModuleConstants.DEFAULT_PRODUCT,
                    value: []
                };
                return [bsPackGroup].concat(data);
            }
            return data;
        }

        function convertPackGroupsFromBusServices(bsPackGroups, termLabelSets) {
            var packGroups = bsPackGroups.map(function(bsPackGroup) {
                var productCode = bsPackGroup.key;
                var bsPacks = bsPackGroup.value;
                var packs = convertPacksFromBusServices(bsPacks, termLabelSets);
                return { productCode: productCode, packs: packs };
            });
            return packGroups;
        }

        function convertPacksFromBusServices(bsPacks, termLabelSets) {
            var packs = bsPacks.map(function(bsPack) {
                var pack = new DealerPack();
                pack.populateFromBusinessServices(bsPack, termLabelSets);
                return pack;
            });
            return packs;
        }

        function checkForUnfriendlyProductCode(productCode) {
            if (productCode.indexOf(':') >= 0) { return productCode.replace(':','-fcolon-');}
            return productCode;
        }

        api.updateDealerPacks = function(productCode, dateOfSale, packs) {
            var deferred = $q.defer();

            if (!(dateOfSale instanceof Date)) {
                dateOfSale = new Date(dateOfSale);
            }
            var dateStr = dateOfSale.mmddyyyy();

            var bsPacks = packs.map(function(pack) { return pack.convertForBusinessServices(); });
            var providerCode =  imSessionVarsService.getCurrentProviderCode();
            var dealerAccount = erateSessionVarsService.getCurrentDealerAccountCode();

            // Todo: fix server side design flaw.  If packs are empty, the server will do nothing because it won't see any product codes.
            var url = AppSettings.startSPANDealerPackSettingsURL +
                "/SaveDealerPackSettings/" + providerCode + "/" + dealerAccount + "/" + dateStr + "/" + checkForUnfriendlyProductCode(productCode);

            commonRESTCallService.postToServer(url, bsPacks)
                .then(function(response) {
                    settingsCacheService.setCachedDealerPacks(productCode, dateOfSale, packs);
                    deferred.resolve(packs);
                },
                function(data, status) {
                    deferred.reject(status + JSON.stringify(data));
                });
            return deferred.promise;
        };

        return api;
}]);

